import React from "react";
import GuideLayout from "../components/layout/GuideLayout";
import Section from "../components/layout/Section";
import Subheader from "../components/layout/Subheader";
import {
  Link,
  Typography,
} from "@mui/material";
import BulletList from "../components/layout/BulletList";

const definitions = [
  `"We" / "Us" / "Our" - The developers and maintainers of the Stylisher Project.`,
  `"You" / "User" - Any person or server using any services from the Stylisher Project (website, userscript, Lebronbot).`,
  `"Service" / "Stylisher" / "Lebronbot" - The Discord bot and all related services operated by us.`
];

const collect = [
  "Server Information: Such as guild ID (server ID), channel ID, and role IDs to provide features and configurations. (Example: Access to our help channels on discord require specific roles.)",
  "Content Shared By You: Message content like your Neopets username, specific trade data, and reported trade values is collected and stored to ensure Lebronbot's essential functions.",
  "Bot Usage Logs: For debugging and improving functionality (e.g., error logs, features used, etc.)."
];

const sections = [
  { id: "privacy-policy", title: "Privacy Policy" },
  {
    id: "collect",
    title: "What We Collect"
  },
  {
    id: "data",
    title: "Data Storage and Retention"
  },
  {
    id: "cookie",
    title: "Cookies and Tracking"
  },
  {
    id: "third-party",
    title: "Third-Party Services"
  },
  {
    id: "rights",
    title: "Your Rights as a User"
  }
];

const PrivacyPolicy = () => {

  return (
    <GuideLayout sections={sections}>
      <Section id="privacy-policy" title="Privacy Policy">
        <Typography
          variant="caption"
          color="secondary"
          sx={{ mt: -1, mb: 2, display: "block" }}
        >
          Last Updated: September 23, 2025 | Effective Date: June 23, 2025
        </Typography>

        <Typography paragraph>
          Your privacy is important to us. This policy explains what personal data the Stylisher project (including Lebronbot) collects and how we use it. We only collect information that is absolutely necessary and access to our database is restricted to necessary personnel.
        </Typography>

        <Subheader title="Definitions" />
        <BulletList items={definitions} />

        <Section>
          <Subheader id="collect" title="1. What We Collect" />
          We do not and never will sell your data for any reason.

          <BulletList items={collect} />
        </Section>

        <Section>
          <Subheader id="data" title="2. Data Storage and Retention" />
          Data is stored securely in a separate database. To provide full and complete Lebronbot functionality, there are no plans to wipe any of the data stored by Lebronbot on a regular basis. We reserve the right to remove any data that we suspect to be in violation of our <Link href="/terms-of-service">terms of use</Link>. We also may edit or delete trade data upon request from the original reporter. You can request your personal data removal at any time (see Section 5).
        </Section>

        <Section>
          <Subheader id="cookie" title="3. Cookies and Tracking" />
          The discord bot does not use cookies. Our Stylisher website only uses essential cookies to keep the site functionality. We do not track your data for any marketing purposes and we never will.
        </Section>

        <Section>
          <Subheader id="third-party" title="4. Third-Party Services" />
          For some features of Lebronbot to fully function, you may need to use your account information and password from a third-party service such as Discord and will need to allow your data to be processed by those services. Their respective privacy policies will apply.
        </Section>

        <Section>
          <Subheader id="rights" title="5. Your Rights as a User" />
          <Typography paragraph>
            You may request your trades to be amended or deleted in the event of any sort of error. To do so, you may have to provide information to identify the right trade to a team member so they may properly assist you.
          </Typography>
          <Typography paragraph>
            You have the right to cease using Lebronbot and request complete removal of your data at any time. If you would like to request full deletion of your data, please <Link href="/contact">contact us through our Discord server</Link> and ask for a full deletion process. Please be aware that your User ID will be blacklisted from interacting with Lebronbot after a full deletion request for security reasons. This would not apply to smaller requests such as edits or brief amendments.
          </Typography>
        </Section>

      </Section>

    </GuideLayout>
  );
};

export default PrivacyPolicy;